import { SVGProps } from ".";

export function PolygonIcon({ color = "black", size = 18 }: SVGProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        color={`${color}`}
        height={`${size}`}
        width={`${size}`}
        stroke={`${color}`}
        strokeWidth="0"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7207 3.5C19.7031 3.50015 20.499 4.29686 20.499 5.2793C20.4989 5.91572 20.1637 6.4718 19.6611 6.78613V17.2119C20.1642 17.5262 20.499 18.0839 20.499 18.7207C20.499 19.7031 19.7031 20.4999 18.7207 20.5C18.0843 20.5 17.5273 20.1646 17.2129 19.6621H6.78711C6.47277 20.1646 5.9157 20.4999 5.2793 20.5C4.29677 20.5 3.5 19.7032 3.5 18.7207C3.50001 17.7382 4.29678 16.9414 5.2793 16.9414C5.31309 16.9414 5.34656 16.9444 5.37988 16.9463L8.81543 9.04004C8.5145 8.7214 8.32812 8.29318 8.32812 7.82031C8.32824 6.83788 9.12497 6.04199 10.1074 6.04199C10.6921 6.04208 11.209 6.32518 11.5332 6.76074L16.9707 4.96289C17.12 4.13129 17.8461 3.5 18.7207 3.5ZM11.8037 8.35645C11.5971 9.01103 11.0223 9.5005 10.3223 9.58496L6.77246 17.7559C6.83477 17.8521 6.88765 17.9547 6.93066 18.0625H17.0684C17.2488 17.6099 17.609 17.249 18.0615 17.0684V6.92969C17.8185 6.83259 17.6022 6.68448 17.4258 6.49707L11.8037 8.35645Z"
          fill={`${color}`}
        />
      </svg>
    </div>
  );
}
